
import { Component, Vue } from 'vue-property-decorator'

// ログイン完了時のレスポンス
export type AuthResponse = {
  headers: {
    'access-token': string
    client: string
    uid: string
  }
  data: {
    data: {
      id: number
      role_type: string
      nickname: string
      branch_id: number
      branch_name: string
      academy_id: number
      academy_name: string
      grade_name: string
    }
  }
}

export type LoginParams = {
  branchCode?: string
  academyCode?: string
  acbtCode?: string
  password?: string
  role?: string
}

/**
 * ログイン画面の共通処理をまとめたMixin用のコンポーネント
 *
 * Mixin先のログイン画面に応じてcreated時にmodeを上書きし、login関数にてログインを実行できる
 * modeに入る値は、MODEを参照
 */
@Component
export default class LoginMethods extends Vue {
  private errorMessages: any[] = []

  private loginApiCalled = false

  /**
   * 生徒ログイン
   */
  protected async studentLogin(accountCode: string, password: string) {
    const params: LoginParams = {
      acbtCode: accountCode,
      password: password,
      role: 'student',
    }
    await this.login(params)
  }

  /**
   * 文理管理者ログイン
   */
  protected async adminLogin(accountCode: string, password: string) {
    const params: LoginParams = {
      acbtCode: accountCode,
      password: password,
      role: 'admin',
    }
    await this.login(params)
  }

  /**
   * 教室管理者ログイン
   */
  protected async branchLogin(accountCode: string, password: string) {
    const params: LoginParams = {
      acbtCode: accountCode,
      password: password,
      role: 'branch',
    }
    await this.login(params)
  }

  /**
   * ログイン処理 (Mixin先で呼び出す)
   *
   * このリクエストで、以下の一連の処理を実行
   * 認証リクエスト-Cookieへの保存 => Topページへの遷移
   */
  protected async login(params: LoginParams) {
    // 二重呼び出し防止
    if (this.loginApiCalled) return
    this.loginApiCalled = true

    Vue.prototype.$loading.start()
    await Vue.prototype.$http.http
      .post('/auth/sign_in', params)
      .then((res: any) => {
        this.setCookieAuth(res)
        this.$router.push('/')
      })
      .catch((error: any) => {
        if (!error.response) {
          this.errorMessages = ['ネットワークエラーが発生しています。']
        } else if (error.response.data.errors) {
          this.errorMessages = error.response.data.errors
        } else {
          this.errorMessages = ['ログイン用の認証情報が正しくありません。\n再度お試しください。']
        }
        // 失敗時は再呼び出し可能に
        this.loginApiCalled = false
      })
      .finally(() => {
        Vue.prototype.$loading.complete()
      })
  }

  /**
   * 認証情報をCookieに保存
   * 内部メソッドの為、外部からの呼び出しは想定していない
   */
  private async setCookieAuth(res: AuthResponse) {
    await Vue.prototype.$cookies.set(
      'authAcbt',
      {
        accessToken: res.headers['access-token'],
        client: res.headers.client,
        uid: res.headers.uid,
        currentApiUserId: res.data.data.id,
        currentApiUserRole: res.data.data.role_type,
        currentApiUserName: res.data.data.nickname,
        currentApiBranchId: res.data.data.branch_id,
        currentApiBranchName: res.data.data.branch_name,
        currentApiAcademyId: res.data.data.academy_id,
        currentApiAcademyName: res.data.data.academy_name,
        currentApiGradeName: res.data.data.grade_name,
      },
      Function(`return (${process.env.VUE_APP_COOKIE_EXPIRE})`)()
    )
  }
}
